import React from 'react';
import {
    Typography,
    Divider,
    Button,
    Card,
    ButtonBase,
    Modal,
} from '@mui/material';
import Snackbar from '../components/Snackbar';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import ShareIcon from '@mui/icons-material/Share';
import CardMedia from '@mui/material/CardMedia';
import { useNavigate } from 'react-router-dom';
import GL_IMAGE from '../../../../static/modern-professional/GalleryLambda-Slide-Issue.png';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import A8Agoda from '../components/A8/modern-proffesional/A8Agoda';
import CardActions from '@mui/material/CardActions';
import FemaleIcon from '@mui/icons-material/Female';
import IconButton from '@mui/material/IconButton';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import WomanIcon from '@mui/icons-material/Woman';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { QUIZ_DATA } from '../../consts';
import autoRefreshedExecuteHasAllClientOrgLicenseStatusWithToken from '../tools/permissions/hasAllClientOrgLicenseStatus';
import Wave from '../../static/onkan/ai-generated-8326626_1280.jpg';
import autoRefreshedExecuteGetCreateExamWithToken from '../tools/getCreateExam';
import LinearProgress from '@mui/material/LinearProgress';
import autoRefreshedExecuteGetStoreExamResultWithToken from '../tools/getStoreExamResult';
import autoRefreshedExecuteHasAllClientOrgRolesWithToken from '../tools/permissions/hasAllClientOrgRoles';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import userGuideImage from '../../static/onkan/user-guide.png'; // Import the user-guide image
import { useLanguage } from '../../contexts/LanguageContext';
import { LANG_CODE } from '../views/AppFooter';


interface GameCardProps {
    path: string;
}

function getQuizDataByPage(page: number) {
    const quizKey = `quiz${page}`;
    return QUIZ_DATA[quizKey] || [];
}

function concatenateAndSort(inputArray: string[]): string {
    // Sort the array alphabetically and join it into a single string
    return inputArray.sort().join('-');
}


const GameCardTest: React.FC<GameCardProps> = ({ path }) => {

    const [hasPermission, setHasPermission] = React.useState<boolean | null>(null);
    const [hasViewPermission, setHasViewPermission] = React.useState<boolean | null>(null);
    const [page, setPage] = React.useState(1);
    const [open, setOpen] = React.useState(false);
    const [answerJudge, setAnswerJudge] = React.useState("")
    const navigate = useNavigate()
    const { language } = useLanguage();

    const accessToken = localStorage.getItem('access_token');

    // Get the value from localStorage, or default to an empty string
    const [examUuid, setExamUuid] = React.useState(() => {
        return localStorage.getItem('currentExamUuid') || '';
    });
    // Whenever `value` changes, update it in localStorage
    React.useEffect(() => {
        localStorage.setItem('currentExamUuid', examUuid);
    }, [examUuid]);

    const [currentExamResult, setCurrentExamResult] = React.useState<{ [key: string]: boolean[] }>(() => {
        const storedResult = localStorage.getItem('currentExamResult');
        return storedResult ? JSON.parse(storedResult) : {};
    });
    React.useEffect(() => {
        localStorage.setItem('currentExamResult', JSON.stringify(currentExamResult));
    }, [currentExamResult]);

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await autoRefreshedExecuteHasAllClientOrgLicenseStatusWithToken(accessToken, "project", "dummyKey", ["professional"]);
                setHasPermission(response.has_all_rights); // Update permission state
            } catch (error) {
                console.error("Error fetching data:", error);
                setHasPermission(false); // Default to no permission on error
            }
        };

        fetchData();
    }, [accessToken]);

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await autoRefreshedExecuteHasAllClientOrgRolesWithToken(accessToken, "project", "dummyKey", ["view"]);
                setHasViewPermission(response.has_all_rights); // Update permission state
            } catch (error) {
                console.error("Error fetching data:", error);
                setHasViewPermission(false); // Default to no permission on error
            }
        };

        fetchData();
    }, [accessToken]);

    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    // Handle loading state
    if (hasPermission === null || hasViewPermission === null) {
        return (
            <Box sx={{ mt: 3, mb: 7, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <Card elevation={0} sx={{ maxWidth: 1000, height: '780px' }} style={{ margin: '0px', padding: '0px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }} >
                        <Typography variant="h5" color="text.primary" sx={{ mt: 0, fontSize: '24px' }}>
                            Loading...
                        </Typography>
                    </Box>
                </Card>
            </Box>
        )
    }

    // Go to signin page if no permission
    if (!hasPermission) {
        navigate("/sign-in/");
        window.scrollTo(0, 0);
        return null;
        // return <NotFoundPage />;
    }
    if (!hasViewPermission) {
        navigate("/sign-in/");
        window.scrollTo(0, 0);
        return null;
        // return <NotFoundPage />;
    }

    const handleAddNewKeyValuePair = (key: string, value: boolean) => {
        setCurrentExamResult(prevResults => ({
            ...prevResults,
            [key]: prevResults[key] ? [...prevResults[key], value] : [value]  // Append or create new array
        }));

    };

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
        // setCorrectWord(options[Math.floor(Math.random() * options.length)]);
    };
    const handleCopyClick = () => {
        navigator.clipboard.writeText(path)
            .then(() => {
                console.log('Link copied to clipboard!');
            })
            .catch((err) => {
                console.error('Unable to copy link to clipboard', err);
            });
    };


    const handleImageClick = (path: string) => {
        navigate(path);
        window.scrollTo(0, 0);
    };
    const quizDataTest = getQuizDataByPage(page);

    const speakWord = (text: string) => {
        if ('speechSynthesis' in window) {
            const utterance = new SpeechSynthesisUtterance(text);
            window.speechSynthesis.speak(utterance);
        } else {
            console.log('Text-to-speech not supported in this browser');
        }
    };
    const options = [quizDataTest[0].word, quizDataTest[1].word];
    // const [correctWord, setCorrectWord] = React.useState(options[Math.floor(Math.random() * options.length)]);
    // if we use the above, then when the pagination changes, it still holds the same correctWord as is so
    // we should add correctWord change logic
    // however, as is the issue is that when the handleFalse is executed, this correctWord gets also defaulted
    const correctWord = options[Math.floor(Math.random() * options.length)]

    const handleAnswerJudgeClick = (userSelectedWord: string, event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        if (correctWord === userSelectedWord) {
            setAnswerJudge("正解 🎉🎉🎉");
        } else {
            setAnswerJudge("Ops 😢😢😢");
        }
        setOpen(true);
    };


    const handleFalse = () => {
        setOpen(false);
    };

    const handleCreateExam = async () => {
        try {
            const response = await autoRefreshedExecuteGetCreateExamWithToken(accessToken);
            setExamUuid(response.exam_uuid)
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleStoreExam = async () => {
        try {
            const response = await autoRefreshedExecuteGetStoreExamResultWithToken(accessToken, examUuid, currentExamResult);

            // // Clear localStorage first
            localStorage.removeItem('currentExamUuid');
            localStorage.removeItem('currentExamResult');

            // localStorage.setItem('currentExamUuid', '')
            // localStorage.setItem('currentExamResult', '{}')

            setExamUuid("");
            setCurrentExamResult({});

            setTimeout(() => {
                console.log(response.store_exam_status);
                navigate("/result"); // Navigate after state updates
            }, 1);

            console.log(response.store_exam_status);
        } catch (error) {
            console.error("Error executing get store exam result", error);
        }
    };

    const getTopMessage = () => {
        switch (language) {
            case LANG_CODE.EN_PROFESSIONAL:
                return 'Let\'s get a score!';
            case LANG_CODE.JA_PROFESSIONAL:
                return 'Let\'s get a score!';
            case LANG_CODE.JA_YOUTH:
                return 'Let\'s get a score!';
            case LANG_CODE.JA_KID:
                return 'てすとをうけてみよう';
        }
    };

    const getDurationText = () => {
        switch (language) {
            case LANG_CODE.EN_PROFESSIONAL:
                return 'Duration: 10 min';
            case LANG_CODE.JA_PROFESSIONAL:
                return 'Duration: 10 min';
            case LANG_CODE.JA_YOUTH:
                return '時間制限: 10分間';
            case LANG_CODE.JA_KID:
                return '10ぷんで がんばろう';
        }
    };

    const getInstructionText = () => {
        switch (language) {
            case LANG_CODE.EN_PROFESSIONAL:
                return 'Instructions';
            case LANG_CODE.JA_PROFESSIONAL:
                return 'Instructions';
            case LANG_CODE.JA_YOUTH:
                return '説明';
            case LANG_CODE.JA_KID:
                return 'せつめい';
        }
    };

    const MainGameCardTestInit = () => (
        <Box sx={{ mt: 3, mb: 7, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <Card elevation={0} sx={{ maxWidth: 1000 }} style={{ marginTop: '230px', marginBottom: '180px', padding: '0px' }}>
                <Card sx={{ display: 'flex' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <CardContent sx={{ flex: '1 0 auto' }}>
                            <Typography
                                component="div"
                                variant="h6"
                                style={{ fontSize: '38px', fontFamily: "'Bradley Hand', cursive", marginBottom: '10px' }}
                            >
                                {getTopMessage()}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                component="div"
                                sx={{ color: 'text.secondary' }}
                            >
                                {getDurationText()}
                            </Typography>
                        </CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pl: 1, pb: 1 }}>
                            <IconButton aria-label="start" onClick={() => handleCreateExam()}>
                                <PlayCircleFilledIcon sx={{ height: 38, width: 38 }} />
                            </IconButton>
                        </Box>
                        <CardActions sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button size="small" onClick={handleOpenModal}>{getInstructionText()}</Button>
                        </CardActions>
                    </Box>
                </Card>
            </Card>

            {/* Modal for displaying the user guide */}
            <Modal
                open={isModalOpen}
                onClose={handleCloseModal}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        backgroundColor: 'white',
                        padding: 2,
                        borderRadius: 2,
                        boxShadow: 24,
                        maxWidth: '90%',
                        maxHeight: '90%',
                        overflow: 'auto',
                    }}
                >
                    <img
                        src={userGuideImage}
                        alt="User Guide"
                        style={{ width: '100%', height: 'auto' }}
                    />
                </Box>
            </Modal>
        </Box>
    );

    const MainGameCardTest = () => (
        <Box sx={{ mt: 3, mb: 7, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <Card elevation={0} sx={{ minWidth: 400 }} style={{ margin: '0px', padding: '0px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {/* TODO: this is a hack to make it center so need to refine the code */}
                    {/* Left Placeholder for Centering */}
                    {page === Object.keys(QUIZ_DATA).length && (
                        <Box sx={{ visibility: page === Object.keys(QUIZ_DATA).length ? 'hidden' : 'visible' }}>
                            <Button variant="outlined" sx={{ visibility: 'hidden' }}>Get Result</Button>
                        </Box>
                    )}
                    {/* Centered Typography */}
                    <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                        <Typography variant="h5" color="text.primary" sx={{ mt: 0, fontSize: '24px' }}>
                            Quiz No.{page}
                        </Typography>
                    </Box>

                    {/* Conditionally Rendered Buttons */}
                    {page === Object.keys(QUIZ_DATA).length && (
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button
                                variant="outlined"
                                onClick={() => handleStoreExam()}
                            // href="/result"
                            // When you click the button with href="/result", the browser immediately navigates to the /result page.
                            // This triggers a full page reload (if you're using a traditional <a> link or href on a <Button>).
                            // The component unmounts before React finishes processing setExamUuid("") and setCurrentExamResult({ }).
                            // Since state updates trigger useEffect, which writes to localStorage, but the effect might not run in time
                            >
                                Get Result
                            </Button>
                        </Box>
                    )}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', pl: 1, pb: 1 }}>
                    <IconButton
                        aria-label="previous"
                        onClick={() => setPage((currentPage) =>
                            currentPage <= 1 ? Object.keys(QUIZ_DATA).length : currentPage - 1
                        )}
                    >
                        <SkipPreviousIcon />
                    </IconButton>
                    <IconButton
                        aria-label="play/pause"
                        onClick={() => speakWord(correctWord)}
                        disabled={open}
                    >
                        <PlayArrowIcon sx={{ height: 38, width: 38 }} />
                    </IconButton>
                    <IconButton
                        aria-label="next"
                        onClick={() => setPage((currentPage) =>
                            currentPage >= Object.keys(QUIZ_DATA).length ? 1 : currentPage + 1
                        )}
                    >
                        <SkipNextIcon />
                    </IconButton>
                </Box>

                <Box sx={{ width: '100%' }}>
                    <LinearProgress
                        variant="determinate"
                        value={((page / Object.keys(QUIZ_DATA).length)) * 100}
                        sx={{
                            backgroundColor: '#e0e0e0', // Background color of the bar
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: '#9e9e9e', // Color of the filled bar
                            },
                        }}
                    />
                </Box>

                <CardContent>
                    <Typography paragraph style={{ fontSize: '22px' }}>
                        {/* <br /> */}
                        <Card elevation={1}>
                            <CardHeader
                                avatar={
                                    <Avatar aria-label="recipe" sx={{ width: 70, height: 70, fontSize: '40px', backgroundColor: quizDataTest[0].color }}>
                                        {quizDataTest[0].targetOnso}
                                    </Avatar>
                                }
                                title={quizDataTest[0].pronauniation}
                                titleTypographyProps={{ fontSize: '40px' }}
                                action={
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <IconButton onClick={() => speakWord(quizDataTest[0].word)}>
                                            <VolumeUpIcon style={{ color: "#e0e0e0", fontSize: 70 }} />
                                        </IconButton>
                                    </Box>
                                }
                            />
                            <Divider />
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <ButtonBase
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                    }}
                                    onClick={() => {
                                        setTimeout(() => {
                                            handleAddNewKeyValuePair(
                                                concatenateAndSort([quizDataTest[0].word, quizDataTest[1].word]),
                                                correctWord === quizDataTest[0].word
                                            );
                                        }, 400); // Add a 400ms delay; otherwise people cannot see the ripple effect
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: { xs: '65px', sm: '120px' },
                                        }}
                                    >
                                        <Typography
                                            variant="h5"
                                            paragraph
                                            sx={{
                                                fontSize: '50px',
                                                marginTop: '16px',
                                            }}
                                        >
                                            {React.createElement(quizDataTest[0].icon, { sx: { fontSize: 30 } })}
                                            {quizDataTest[0].word}
                                        </Typography>
                                    </CardContent>
                                </ButtonBase>
                            </Box>
                        </Card>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: { xs: '50px', sm: '60px' } }}>
                            <CardContent>
                                <Typography id="3" variant="h5" style={{ fontSize: '30px', marginTop: '0px' }}>v.s.</Typography>
                            </CardContent>
                        </Box>
                        <Card elevation={1}>
                            <CardHeader
                                avatar={
                                    <Avatar aria-label="recipe" sx={{ width: 70, height: 70, fontSize: '40px', backgroundColor: quizDataTest[1].color }}>
                                        {quizDataTest[1].targetOnso}
                                    </Avatar>
                                }
                                title={quizDataTest[1].pronauniation}
                                titleTypographyProps={{ fontSize: '40px' }}
                                action={
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <IconButton onClick={() => speakWord(quizDataTest[1].word)}>
                                            <VolumeUpIcon style={{ color: "#e0e0e0", fontSize: 70 }} />
                                        </IconButton>
                                    </Box>
                                }
                            />
                            <Divider />
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <ButtonBase
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                    }}
                                    onClick={() => {
                                        setTimeout(() => {
                                            handleAddNewKeyValuePair(
                                                concatenateAndSort([quizDataTest[0].word, quizDataTest[1].word]),
                                                correctWord === quizDataTest[1].word
                                            );
                                        }, 400); // Add a 400ms delay; otherwise people cannot see the ripple effect
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: { xs: '65px', sm: '120px' },
                                        }}
                                    >
                                        <Typography
                                            variant="h5"
                                            paragraph
                                            sx={{
                                                fontSize: '50px',
                                                marginTop: '16px',
                                            }}
                                        >
                                            {React.createElement(quizDataTest[1].icon, { sx: { fontSize: 30 } })}
                                            {quizDataTest[1].word}
                                        </Typography>
                                    </CardContent>
                                </ButtonBase>
                            </Box>
                        </Card>
                    </Typography>
                </CardContent>
                {/* <Divider style={{ margin: '10px 0' }} /> */}
                {/* <CardContent style={{ width: '430px' }}>
                    <A8Agoda />
                </CardContent> */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Stack spacing={2}>
                        <Pagination
                            count={Object.keys(QUIZ_DATA).length}
                            page={page}
                            onChange={handleChange}
                        />
                    </Stack>
                </Box>
                <br />
                <Button
                    variant="text"
                    size="small"
                    endIcon={<ShareIcon />}
                    sx={{
                        color: 'black',
                        marginLeft: { xs: '20px', sm: '5px' }
                    }}
                    onClick={() => handleImageClick("/")}
                >
                    Go to Top Page
                </Button>
            </Card >
            <Snackbar
                open={open}
                autoHideDuration={2000}
                onClose={handleFalse}
                closeFunc={handleFalse}
                message={answerJudge}
            />
        </Box >
    );

    return (
        examUuid ? <MainGameCardTest /> : <MainGameCardTestInit />
    );
};

export default GameCardTest;
